import { render, staticRenderFns } from "./FullFunnelChart.vue?vue&type=template&id=2ed08327&scoped=true"
import script from "./FullFunnelChart.vue?vue&type=script&lang=js"
export * from "./FullFunnelChart.vue?vue&type=script&lang=js"
import style0 from "./FullFunnelChart.vue?vue&type=style&index=0&id=2ed08327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed08327",
  null
  
)

export default component.exports